import React, { useCallback } from "react";

import SearchFormCalendar from "./search_form_calendar";

const SearchForm = ({ myPref, mainGenreKey, keyword }) => {
  const eventDateFunc = useCallback(
    (dateStr) => {
      if (typeof window !== "undefined") {
        const searchOption =
          (keyword ? `&keyword=${keyword}` : "") +
          (mainGenreKey ? `&main_genre_key=${mainGenreKey}` : "");
        location.href = `/search/${
          myPref ? myPref.pref_key : "all"
        }?event_date=${dateStr}${searchOption}`;
      }
    },
    [myPref, keyword, mainGenreKey]
  );

  return (
    <div>
      <div className="container">
        <p className="text-center small pt-4 mb-3" style={{ color: "#575757" }}>
          日付で探す
        </p>
        <SearchFormCalendar eventDate={null} eventDateFunc={eventDateFunc} />
      </div>
    </div>
  );
};

export default SearchForm;
